import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaTipoAluno = (): TabelaColuna => ({
  Chave: 'tipoAluno',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Tipo Aluno</div>
})
